import React from 'react'
import { components } from 'react-select'
import classnames from 'classnames'

import { useStyles } from '../styles'

const SelectMenu = props => {
  const { isIconSelect, menuContainerClassName } = props.selectProps

  const classes = useStyles({ isIconSelect })

  return (
    <div className={classnames(classes.menuContainer, menuContainerClassName)}>
      <components.Menu {...props} className={classes.menu} />
    </div>
  )
}

export default SelectMenu
